<div class="crud-table ibc-border-table table-input-field {{ isFrom }}">
  <!-- Empty state message -->
  <ng-container *ngIf="isNoAddedRowsInAP() && pageMode !== 'View'">
    <div
      class="ibc-grid-message-text initial-search-text empty-state-message-container">
      <ng-content select="[slot=empty-state]"></ng-content>
    </div>
  </ng-container>
  <div
    *ngIf="showLinehaulMismatchBanner"
    class="linehaul-info-banner-container">
    <app-svg-icon
      [isStaticSvg]="true"
      [iconName]="'infoCircle'"
      class="cursor banner-info-icon"></app-svg-icon>
    <div class="linehaul-banner-content-container">
      <span class="ibc-body-text-regular">{{ lineHaulInfoMessage }}</span>
    </div>
  </div>

  <mat-table
    [dataSource]="inlineCrudTableDataSource"
    [class.hide-table-rows]="shouldShowInlineEmptyStateMessage()">
    <mat-header-row
      *matHeaderRowDef="inlineTableDisplayedColumns"
      class="ibc-body-text-large-bold"></mat-header-row>

    <ng-container>
      <mat-row
        *matRowDef="
          let row;
          let i = index;
          columns: inlineTableDisplayedColumns
        "
        [class.linehaul-mismatch]="isLinehaulMismatchRow(row)"></mat-row>
    </ng-container>

    <mat-divider></mat-divider>

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? toggleAllRows() : null"
          [checked]="isHeaderCheckboxChecked()"
          [indeterminate]="isHeaderCheckboxIndeterminate()"
          [disabled]="checkForEnableOrDisable() || isEditIconClicked">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <mat-checkbox
          *ngIf="
            !tableService.inlineEditTableRowContainsInput(row) &&
            !isLockedRow(row) &&
            (i > 0 || (i === 0 && pageMode !== 'Add'))
          "
          (change)="
            $event.checked ? checked(row) : unchecked(row);
            emitCreateSelectionChange()
          "
          [checked]="isChecked(row)"
          [disabled]="isEditIconClicked"
          (keydown)="$event.stopPropagation()">
        </mat-checkbox>
        <mat-icon
          *ngIf="isLockedRow(row)"
          class="locked-row-icon"
          tabindex="0"
          role="img"
          [attr.aria-label]="lockedApChargeTooltip"
          [matTooltip]="lockedApChargeTooltip">
          lock
        </mat-icon>
      </mat-cell>
    </ng-container>

    <form [formGroup]="inlineCrudTableForm">
      <ng-container
        formArrayName="rows"
        *ngFor="let item of customiseInlineCrudTableColumns; let i = index"
        [matColumnDef]="item.key">
        <ng-container
          *ngFor="let roleForm of getRows().controls; let rowIndex = index">
          <mat-header-cell *matHeaderCellDef>
            <span class="column-header cursor">
              <span class="ibc-body-text-large">{{ item.label }}</span>
            </span>
          </mat-header-cell>

          <mat-cell
            *matCellDef="let element; let rowIndex = index"
            [formGroupName]="rowIndex">
            <mat-form-field
              *ngIf="item.key === 'measurementOptions'"
              appearance="outline"
              class="mat-sm mat-multiple-select">
              <mat-select [formControlName]="item.key">
                <mat-option
                  *ngFor="let option of measurementOptionsList"
                  [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
              <mat-icon matPrefix class="dropdown-icon">
                {{ actionIcons.keyboardDownArrow }}
              </mat-icon>
              <app-field-clear-suffix
                matSuffix
                [large]="false"
                [control]="getRows().at(rowIndex).get(item.key)"
                (cleared)="onInlineSelectCleared(item.key, rowIndex)" />
            </mat-form-field>

            <mat-form-field
              *ngIf="item.key === 'shipmentIdentifier'"
              appearance="outline"
              class="mat-sm custom-select mat-select-variants shipmentIdentifier">
              <mat-select
                [formControlName]="item.key"
                (selectionChange)="
                  onShipmentIndentifierChange($event, rowIndex)
                ">
                <mat-option
                  *ngFor="let option of shipmentIdentifierData"
                  [value]="option.name">
                  {{ option.name }}
                </mat-option>
              </mat-select>
              <mat-icon matPrefix class="dropdown-icon">
                {{ actionIcons.keyboardDownArrow }}
              </mat-icon>
              <app-field-clear-suffix
                matSuffix
                [large]="false"
                [control]="getRows().at(rowIndex).get(item.key)"
                (cleared)="onInlineSelectCleared(item.key, rowIndex)" />
            </mat-form-field>

            <mat-form-field
              *ngIf="item.key === 'origin'"
              appearance="outline"
              class="mat-sm">
              <input
                appFocusClickOnTab
                matInput
                type="text"
                [formControlName]="item.key"
                autocomplete="off"
                (click)="
                  isOriginFieldEnabled(rowIndex) &&
                    onLookupSearchIconClicked('origin', rowIndex)
                "
                (keydown)="commonService.preventTypingOrPasting($event)"
                (paste)="commonService.preventTypingOrPasting($event)" />
              <span
                *ngIf="
                  shouldShowOriginIcons(rowIndex) &&
                  !checkControlHasError(rowIndex, item.key)
                "
                matSuffix
                class="origin-field-icons {{
                  getRows().at(rowIndex).get('origin')?.value
                    ? 'set-height'
                    : ''
                }}">
                <app-svg-icon
                  [iconName]="'lookupSearch'"
                  class="lookupSearch-icon cursor {{
                    getRows().at(rowIndex).get('origin')?.value
                      ? 'set-height'
                      : ''
                  }}"
                  [isStaticSvg]="true"
                  (click)="onLookupSearchIconClicked('origin', rowIndex)"
                  (keydown)="$event.stopPropagation()">
                </app-svg-icon>
                <app-svg-icon
                  *ngIf="getRows().at(rowIndex).get('origin')?.value"
                  [iconName]="'close'"
                  class="dropdown-close-icon cursor"
                  [isStaticSvg]="true"
                  (click)="clearLookupFieldValues('origin', rowIndex)"
                  (keydown)="$event.stopPropagation()">
                </app-svg-icon>
              </span>
              <app-svg-icon
                *ngIf="checkControlHasError(rowIndex, item.key)"
                matSuffix
                [iconName]="'infoCircle'"
                [isStaticSvg]="true"
                [isFrom]="'Page'"
                class="cursor info-icon-error"
                (click)="fetchWidth($event, item.key)"
                (keydown)="$event.stopPropagation()"></app-svg-icon>
              <app-custom-error-tooltip
                *ngIf="
                  checkControlHasError(rowIndex, item.key) &&
                  setInlineCrudTableErrorTooltip[item.key]
                "
                [tooltipWidth]="setInlineCrudTableWidth[item.key]"
                [tooltipText]="getErrorMessage(rowIndex, item.key)"
                (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    item.key,
                    setInlineCrudTableErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>

            <mat-form-field
              *ngIf="item.key === 'countryCode'"
              appearance="outline"
              class="mat-sm">
              <input
                appFocusClickOnTab
                matInput
                type="text"
                [formControlName]="item.key"
                autocomplete="off"
                (click)="
                  isCountryFieldEnabled(rowIndex) &&
                    onLookupSearchIconClicked('countryCode', rowIndex)
                "
                (keydown)="commonService.preventTypingOrPasting($event)"
                (paste)="commonService.preventTypingOrPasting($event)" />
              <span
                *ngIf="shouldShowCountryIcons(rowIndex)"
                matSuffix
                class="countryCode-field-icons {{
                  getRows().at(rowIndex).get('countryCode')?.value
                    ? 'set-height'
                    : ''
                }}">
                <app-svg-icon
                  [iconName]="'lookupSearch'"
                  class="lookupSearch-icon cursor {{
                    getRows().at(rowIndex).get('countryCode')?.value
                      ? 'set-height'
                      : ''
                  }}"
                  [isStaticSvg]="true"
                  (click)="onLookupSearchIconClicked('countryCode', rowIndex)"
                  (keydown)="$event.stopPropagation()">
                </app-svg-icon>
                <app-svg-icon
                  *ngIf="getRows().at(rowIndex).get('countryCode')?.value"
                  [iconName]="'close'"
                  class="dropdown-close-icon cursor"
                  [isStaticSvg]="true"
                  (click)="clearLookupFieldValues('countryCode', rowIndex)"
                  (keydown)="$event.stopPropagation()">
                </app-svg-icon>
              </span>
            </mat-form-field>

            <!-- Agent Charge Code dropdown with Add New and View links for AP Charge Code -->
            <mat-form-field
              *ngIf="
                item.key === 'agentChargeCode' &&
                isFrom === selectionTableNames.ApChargeCode
              "
              appearance="outline"
              class="mat-sm mat-multiple-select remove-subscript-wrapper">
              <mat-select
                [formControlName]="item.key"
                (selectionChange)="
                  onAgentChargeCodeSelectionChange($event, rowIndex)
                "
                #agentChargeCodeSelect="matSelect">
                <mat-select-trigger>
                  {{ getRows().at(rowIndex).get(item.key)?.value }}
                </mat-select-trigger>
                <mat-option
                  class="no-checkbox"
                  (keydown)="$event.stopPropagation()"
                  (click)="
                    closeAgentChargeCodeDropdown(agentChargeCodeSelect);
                    onAgentChargeCodeAddNewClick(rowIndex)
                  ">
                  <span class="ibc-body-link-text-medium text-hyperlink">
                    Add New Agent Charge Code
                  </span>
                </mat-option>
                <mat-option
                  *ngFor="let option of getAgentChargeCodeDropdownList()"
                  [value]="option.name">
                  <span tabindex="-1" (keydown)="$event.stopPropagation()">
                    {{ option.name }}
                    <span
                      class="ibc-body-link-text-medium text-hyperlink"
                      (keydown)="$event.stopPropagation()"
                      (click)="
                        closeAgentChargeCodeDropdown(agentChargeCodeSelect);
                        onAgentChargeCodeViewClick(option.id, rowIndex)
                      ">
                      View
                    </span>
                  </span>
                </mat-option>
              </mat-select>
              <mat-icon matPrefix class="dropdown-icon">
                {{ actionIcons.keyboardDownArrow }}
              </mat-icon>
              <div matSuffix class="field-suffix-icons">
                <app-field-clear-suffix
                  [large]="false"
                  [control]="getRows().at(rowIndex).get(item.key)"
                  (cleared)="onInlineSelectCleared(item.key, rowIndex)" />
                <app-svg-icon
                  *ngIf="checkControlHasError(rowIndex, item.key)"
                  [iconName]="'infoCircle'"
                  [isStaticSvg]="true"
                  [isFrom]="'Page'"
                  class="cursor info-icon-error"
                  (click)="fetchWidth($event, item.key)"
                  (keydown)="$event.stopPropagation()"></app-svg-icon>
              </div>
              <app-custom-error-tooltip
                *ngIf="
                  checkControlHasError(rowIndex, item.key) &&
                  setInlineCrudTableErrorTooltip[item.key]
                "
                [tooltipWidth]="setInlineCrudTableWidth[item.key]"
                [tooltipText]="getErrorMessage(rowIndex, item.key)"
                (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    item.key,
                    setInlineCrudTableErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="mat-sm mat-form-field-disabled"
              *ngIf="
                getInlineTableAutocompleteFields(item.key) &&
                !(
                  item.key === 'agentChargeCode' &&
                  isFrom === selectionTableNames.ApChargeCode
                ) &&
                !isShipmentIdentifierValueHyperlink(
                  item.key,
                  element,
                  rowIndex
                ) &&
                !isPlainTextIdentifierDisplay(item.key, element, rowIndex) &&
                !isInvoiceNumberHyperlink(item.key, element)
              ">
              <mat-icon matPrefix class="dropdown-icon">
                {{ actionIcons.keyboardDownArrow }}
              </mat-icon>
              <input
                matInput
                [formControlName]="item.key"
                [matAutocomplete]="autoCompleteDropdown"
                (input)="formAutocompleteValueChanges(item.key, rowIndex)" />
              <mat-autocomplete
                #autoCompleteDropdown="matAutocomplete"
                (keydown)="$event.stopPropagation()"
                (optionSelected)="
                  onOptionSelectedFormChanges(item.key, rowIndex)
                ">
                <mat-option
                  *ngFor="
                    let data of getAutocompleteOptionsList(item.key, rowIndex)
                      | async
                  "
                  [value]="data.name">
                  {{ data.name }}
                </mat-option>
              </mat-autocomplete>
              <div matSuffix class="field-suffix-icons">
                <app-field-clear-suffix
                  [large]="false"
                  [control]="getRows().at(rowIndex).get(item.key)"
                  [autocomplete]="true"
                  (cleared)="onInlineAutocompleteCleared(item.key, rowIndex)" />
                <app-svg-icon
                  *ngIf="checkControlHasError(rowIndex, item.key)"
                  [iconName]="'infoCircle'"
                  [isStaticSvg]="true"
                  [isFrom]="'Page'"
                  class="cursor info-icon-error"
                  (click)="fetchWidth($event, item.key)"
                  (keydown)="$event.stopPropagation()"></app-svg-icon>
              </div>
              <app-custom-error-tooltip
                *ngIf="
                  checkControlHasError(rowIndex, item.key) &&
                  setInlineCrudTableErrorTooltip[item.key]
                "
                [tooltipWidth]="setInlineCrudTableWidth[item.key]"
                [tooltipText]="getErrorMessage(rowIndex, item.key)"
                (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    item.key,
                    setInlineCrudTableErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>

            <span
              *ngIf="
                isShipmentIdentifierValueHyperlink(item.key, element, rowIndex)
              "
              class="shipment-identifier-ufo-cell">
              <span
                class="ibc-body-text-medium text-hyperlink cursor"
                (click)="onShipmentIdentifierValueClick(element, rowIndex)"
                (keydown)="$event.stopPropagation()"
                [attr.aria-hidden]="true">
                {{ element[item.key] }}
              </span>
              <div
                *ngIf="element?.isUFOShipment === true"
                class="ufo-shipment-info-icon"
                [matTooltip]="ufoShipmentIdentifierTooltip"
                matTooltipPosition="above"
                (keydown)="$event.stopPropagation()">
                <app-svg-icon
                  [iconName]="'infoCircle'"
                  [isStaticSvg]="true"
                  [isFrom]="'Page'"
                  class="info-icon hawb-info-block cursor"></app-svg-icon>
              </div>
            </span>

            <!-- Plain text for entries WITHOUT valid Shipment ID / MAWB ID (no hyperlink) -->
            <span
              *ngIf="isPlainTextIdentifierDisplay(item.key, element, rowIndex)"
              class="ibc-body-text-medium">
              {{ element[item.key] }}
            </span>

            <span
              *ngIf="isInvoiceNumberHyperlink(item.key, element)"
              class="ibc-body-text-medium text-hyperlink cursor"
              (click)="onInvoiceNumberClick(element, rowIndex)"
              (keydown)="$event.stopPropagation()"
              [attr.aria-hidden]="true">
              {{ element[item.key] }}
            </span>

            <mat-form-field
              appearance="outline"
              class="mat-sm"
              *ngIf="
                (getInlineTableInputFormControl(item.key) ||
                  getDatePickerKeys(item.key)) &&
                !externalAutocompleteKeys.includes(item.key) &&
                !isShipmentIdentifierValueHyperlink(
                  item.key,
                  element,
                  rowIndex
                ) &&
                !isPlainTextIdentifierDisplay(item.key, element, rowIndex) &&
                !isInvoiceNumberHyperlink(item.key, element)
              ">
              <input
                *ngIf="
                  getIdentifierValueKey(item.key) &&
                  !shouldApplyNumbersWithHyphenDirective(rowIndex, item.key)
                "
                matInput
                [formControlName]="item.key"
                (blur)="onInputBlur(rowIndex, item.key)" />
              <input
                *ngIf="
                  getIdentifierValueKey(item.key) &&
                  shouldApplyNumbersWithHyphenDirective(rowIndex, item.key)
                "
                matInput
                [formControlName]="item.key"
                appNumbersWithHyphen
                (blur)="onInputBlur(rowIndex, item.key)" />
              <input
                *ngIf="
                  getChargeAmountKeys(item.key) && !getChargeAmountKey(item.key)
                "
                matInput
                [formControlName]="item.key"
                [appDigitWithTwoDecimalNumber]="126"
                (input)="onInputChanges(rowIndex, item.key)"
                (blur)="validateInput(rowIndex, item.key)" />
              <input
                *ngIf="getMarkUpKey(item.key)"
                matInput
                [formControlName]="item.key"
                [appDigitWithTwoDecimalNumber]="2"
                (input)="onInputChanges(rowIndex, item.key)" />
              <input
                *ngIf="getChargeAmountKey(item.key)"
                matInput
                [formControlName]="item.key"
                [appDigitWithTwoDecimalNumber]="126"
                (input)="onInputChanges(rowIndex, item.key)"
                (blur)="validateInput(rowIndex, item.key)" />
              <input
                *ngIf="getPostalCodeKeys(item.key)"
                matInput
                [formControlName]="item.key"
                (input)="onInputChanges(rowIndex, item.key)"
                appPostalCode />
              <input
                appTrimInput
                *ngIf="getPalletsKeys(item.key)"
                matInput
                [formControlName]="item.key"
                [appDigitWithTwoDecimalNumber]="(item.key === 'dimensionalWeight' || item.key === 'actualWeight') ? 9 : 4"
                (input)="onInputChanges(rowIndex, item.key)"
                (blur)="validateInput(rowIndex, item.key)" />
              <ng-container *ngIf="getDatePickerKeys(item.key)">
                <input
                  matInput
                  [matDatepicker]="datePicker"
                  [formControlName]="item.key"
                  (dateChange)="datePickerChange.emit({ rowIndex: rowIndex, key: item.key })" />
                <mat-datepicker #datePicker></mat-datepicker>
              </ng-container>
              <input
                appTrimInput
                *ngIf="getOtherInputKeys(item.key)"
                matInput
                [formControlName]="item.key"
                [attr.data-nr-start]="
                  isFrom === numberRangesEditSetRange &&
                  item.key === 'startNumber' &&
                  rowIndex === 0
                    ? 'true'
                    : null
                "
                (input)="onInputChanges(rowIndex, item.key)"
                (blur)="onInputBlur(rowIndex, item.key)" />
              <app-svg-icon
                matSuffix
                *ngIf="
                  item.key === 'dimensionalFactor' ||
                  item.key === 'dimensionalWeight'
                "
                [iconName]="'infoCircle'"
                [isStaticSvg]="true"
                [isFrom]="'Page'"
                class="info-icon hawb-info-block cursor"
                matTooltipPosition="above"
                [matTooltip]="getPalletsTooltip(item.key)">
              </app-svg-icon>
              <app-svg-icon
                matSuffix
                *ngIf="checkControlHasError(rowIndex, item.key)"
                [iconName]="'infoCircle'"
                [isStaticSvg]="true"
                [isFrom]="'Page'"
                class="cursor info-icon-error"
                (click)="fetchWidth($event, item.key)"
                (keydown)="$event.stopPropagation()"></app-svg-icon>
              <app-custom-error-tooltip
                *ngIf="
                  checkControlHasError(rowIndex, item.key) &&
                  setInlineCrudTableErrorTooltip[item.key]
                "
                [tooltipWidth]="setInlineCrudTableWidth[item.key]"
                [tooltipText]="getErrorMessage(rowIndex, item.key)"
                (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    item.key,
                    setInlineCrudTableErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>

            <div
              class="inputWithInfoicon"
              *ngIf="
                isFrom === numberRangesEditSetRange && item.key === 'priority'
              ">
              <mat-form-field appearance="outline" class="mat-sm">
                <input
                  matInput
                  [formControlName]="item.key"
                  (keypress)="restrictTypingForPriority(rowIndex, $event)"
                  (input)="onPriorityInput(rowIndex)"
                  (blur)="onPriorityInput(rowIndex)" />
                <app-svg-icon
                  matSuffix
                  *ngIf="checkControlHasError(rowIndex, item.key)"
                  [iconName]="'infoCircle'"
                  [isStaticSvg]="true"
                  [isFrom]="'Page'"
                  class="cursor info-icon-error"
                  (click)="fetchWidth($event, item.key, rowIndex)"
                  (keydown)="$event.stopPropagation()"></app-svg-icon>
                <app-custom-error-tooltip
                  *ngIf="
                    checkControlHasError(rowIndex, item.key) &&
                    isInlineErrorTooltipOpen(item.key, rowIndex)
                  "
                  [tooltipWidth]="
                    getInlineErrorTooltipWidth(item.key, rowIndex)
                  "
                  [tooltipText]="getErrorMessage(rowIndex, item.key)"
                  (tooltipCloseClicked)="
                    closeInlineErrorTooltip(item.key, rowIndex)
                  ">
                </app-custom-error-tooltip>
              </mat-form-field>
              <span *ngIf="!checkControlHasError(rowIndex, item.key)">
                <app-svg-icon
                  [iconName]="'infoCircle'"
                  [isStaticSvg]="true"
                  [isFrom]="'Page'"
                  class="cursor set-grid-icons"
                  (click)="priorityFieldTooltipStatus(item.key, rowIndex)"
                  (keydown)="$event.stopPropagation()"></app-svg-icon>
                <app-custom-help-info-tooltip
                  *ngIf="
                    isOpened[rowIndex] &&
                    !checkControlHasError(rowIndex, item.key)
                  "
                  [tooltipWidth]="'97px'"
                  [tooltipText]="
                    'Set priority from 1 to 10. Each priority must be unique'
                  "
                  [tooltipDirection]="'num-range-priority'"
                  (tooltipCloseClicked)="
                    priorityFieldTooltipStatus(item.key, rowIndex)
                  ">
                </app-custom-help-info-tooltip>
              </span>
            </div>

            <span *ngIf="item.key === 'lastUsedNumber'">{{
              element[item.key] === 0 ? '' : element[item.key]
            }}</span>

            <span *ngIf="item.key === 'published'">{{
              element[item.key] || ''
            }}</span>
          </mat-cell>
        </ng-container>
      </ng-container>
    </form>

    <!-- Action column -->
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        <span
          class="ibc-body-text-large"
          *ngIf="isFrom !== numberRangesEditSetRange"
          >Actions</span
        >
      </mat-header-cell>
      <ng-container>
        <mat-cell *matCellDef="let element; let i = index">
          <span
            *ngIf="
              i === 0 &&
              pageMode !== 'View' &&
              (isFrom === numberRangesEditSetRange ||
                isFrom === rsAccessorialManualEntry) &&
              isMaximumRangesAdded()
            ">
            <app-svg-icon
              [isStaticSvg]="true"
              [iconName]="'add_2'"
              class="set-grid-icons"
              (click)="addNewNumberRangeDetails()"
              (keydown)="$event.stopPropagation()"></app-svg-icon>
          </span>
          <span
            *ngIf="
              i !== 0 &&
              pageMode !== 'View' &&
              (isFrom === numberRangesEditSetRange ||
                isFrom === 'rs-accessorial-manual-entry')
            ">
            <app-svg-icon
              [isStaticSvg]="true"
              [iconName]="'delete'"
              class="set-grid-icons"
              (click)="deleteNumberRangeDetails(element)"
              (keydown)="$event.stopPropagation()"></app-svg-icon>
          </span>
          <span
            *ngIf="
              isFrom === 'hawb-transit-points' &&
              editingRowIndex !== i &&
              editingRowIndex === null &&
              inlineCrudTableDataSource.data.length > 1 &&
              !element.outTPDate
            ">
            <app-svg-icon
              [isStaticSvg]="true"
              [iconName]="actionIcons.edit"
              class="set-grid-icons cursor"
              (click)="editTransitPoint(i)"
              (keydown)="$event.stopPropagation()"></app-svg-icon>
          </span>
          <span
            *ngIf="isFrom === 'hawb-transit-points' && editingRowIndex === i"
            class="save-discard-container">
            <app-svg-icon
              [isStaticSvg]="true"
              [iconName]="actionIcons.tick"
              class="set-grid-icons cursor"
              (click)="saveTransitPoint(i)"
              (keydown)="$event.stopPropagation()"></app-svg-icon>
            <app-svg-icon
              [isStaticSvg]="true"
              [iconName]="actionIcons.close"
              class="set-grid-icons cursor"
              (click)="closeTransitPoint(i)"
              (keydown)="$event.stopPropagation()"></app-svg-icon>
          </span>
          <!-- Custom Action Template (provided by parent) -->
          <ng-container *ngIf="customActionTemplate">
            <ng-container
              *ngTemplateOutlet="
                customActionTemplate;
                context: { $implicit: element, index: i, row: getRows().at(i) }
              ">
            </ng-container>
          </ng-container>
        </mat-cell>
      </ng-container>
    </ng-container>
  </mat-table>
  <ng-container *ngIf="shouldShowInlineEmptyStateMessage()">
    <div
      class="ibc-grid-message-text initial-search-text empty-state-message-container">
      {{ inlineEmptyStateMessage }}
    </div>
  </ng-container>
</div>
